import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import MemberDetails from '../members/MemberDetails';
import { ProfileMemberOutletContext } from './ProfileSectionShells';
import {
  MemberMobileShell,
  MemberMobileHero,
} from '../../components/MemberMobileShell';

/**
 * `/profile` : sans fiche People → message + lien compte.
 * Avec person_id → affichage direct de la fiche membre (plus de sous-chemin `/profile/membre`).
 */
const ProfileOverview = () => {
  const { t } = useTranslation('common');
  const { user } = useAuth();
  const personId = String(user?.member_id || user?.person_id || '').trim();

  const ctx = useMemo(
    () => ({ profileMemberId: personId, profileShell: 'membre' }),
    [personId]
  );

  if (!personId) {
    return (
      <div className="mx-auto max-w-lg space-y-3 md:max-w-2xl md:space-y-4">
        <MemberMobileShell>
          <MemberMobileHero
            label={t('memberPortal.profile')}
            title={t('profilePage.noPerson')}
            hint={t('profilePage.indexNoMemberHint')}
            tone="info"
            actions={
              <Link to="/profile/compte" className="mm-cta flex-1">
                {t('profilePage.goToAccount')}
              </Link>
            }
          />
        </MemberMobileShell>

        <div className="entrea-portal-panel hidden p-6 md:block md:p-8">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500">
            {t('memberPortal.profile')}
          </p>
          <h2 className="mt-2 font-display text-xl font-extrabold tracking-tight text-[#0f3350]">
            {t('profilePage.noPerson')}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            {t('profilePage.indexNoMemberHint')}
          </p>
          <Link to="/profile/compte" className="entrea-btn-primary mt-6">
            {t('profilePage.goToAccount')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <ProfileMemberOutletContext.Provider value={ctx}>
      <MemberDetails />
    </ProfileMemberOutletContext.Provider>
  );
};

export default ProfileOverview;
